import RecommendationsBanner from "./RecommendationsBanner.tsx";
import MainBanner from "./MainBanner.tsx";
import { UserPreferenceKey } from "../../../../common/api/decimal/methods/user.ts";
import BannerManager from "../../common/onboarding-banner/BannerManager.tsx";
import NewNavBanner from "./NewNavBanner.tsx";

export default function DashboardBanners() {
  return (
    <BannerManager
      dismissKeys={[
        UserPreferenceKey.DashboardOnboardingBannerDismissed,
        UserPreferenceKey.DashboardRecommendationsBannerDismissed,
        UserPreferenceKey.DashboardNewNavBannerDismissed,
      ]}
    >
      <NewNavBanner />
      <RecommendationsBanner />
      <MainBanner />
    </BannerManager>
  );
}
